import { baseApiUrl } from '@fund-base/constants/general/general.constants';

export const workplanBaseApiUrl = `${baseApiUrl}/work-plans`;
export const workplanFundsSearchApiUrl = `${baseApiUrl}/work-plans/funds/search`;

export const taskBaseApiUrl = `${baseApiUrl}/work-plans`;

export const fileServiceApiUrl = `${baseApiUrl}/files`;
